import type { FC, ReactNode} from 'react';
import React, {type CSSProperties} from 'react'
import {InternalLink} from './external-links'
import type {ClassValue, FCOptChildren, FCReqChildren} from '../helpers/react-helpers'
import classNames from 'classnames'
import {NotSetText} from './grid-form'

export const enum BookingLinkWrapMode {
    MULTILINE,
    ELLIPSIS,
    NO_WRAP,
}

type BookingLinkProps = Override<React.ComponentPropsWithoutRef<typeof InternalLink>, {
    bookingId: number
    /** @deprecated Use `maxWidth` */
    width?: React.CSSProperties['width'],
    maxWidth?: React.CSSProperties['width'],
    className?: ClassValue
    multiline?: boolean
    wrapMode?: BookingLinkWrapMode
}, 'route' | 'params'>

export const BookingLink: React.FC<BookingLinkProps> = ({
    bookingId,
    className,
    width,
    maxWidth,
    style,
    wrapMode = BookingLinkWrapMode.ELLIPSIS,
    ...props
}) => {
    return <InternalLink
        route="bookings.show"
        params={{id: bookingId}}
        className={classNames(wrapMode === BookingLinkWrapMode.NO_WRAP ? 'no-wrap' : (wrapMode === BookingLinkWrapMode.MULTILINE ? 'pre-wrap' : 'ellipsis'), className)}
        style={{maxWidth: wrapMode === BookingLinkWrapMode.ELLIPSIS ? maxWidth ?? width : undefined, ...style}} {...props} />
}

export const NotSet: FCOptChildren = ({children = "Not Set"}) => <NotSetText>{children}</NotSetText>

export const NotSetFallback: FC<{
    children: ReactNode;
    fallback?: ReactNode;
}> = ({children, fallback = "Not Set"}) => {
    if(children == null || children === "") {  // 0 is allowed to render
        return <NotSetText>{fallback}</NotSetText>
    }
    return <>{children}</> // Wrap children in a React.Fragment to ensure a ReactElement
}

export const NotSetBookingLink: FCReqChildren<{ bookingId: number, style?: CSSProperties }> = ({
    bookingId,
    style,
    children = "Not Set"
}) =>
    <BookingLink bookingId={bookingId} style={style}><NotSet>{children}</NotSet></BookingLink>
